const desktopBackFillSize = [728, 90];
const mobileBackFillSize = [300, 250];
const listingAdSizes = [mobileBackFillSize, 'fluid', [1, 525]];

const desktopSizes = [desktopBackFillSize, [728, 200], 'fluid'];
const kbbMobileSizes = [[320, 50], mobileBackFillSize, [306, 435], 'fluid'];
const atcMobileSizes = [mobileBackFillSize, [306, 435], 'fluid'];

export const AD_CONFIGS = {
    atc: {
        default: {
            0: { id: 'spotlightAd-toptier', position: 'b', sizes: desktopSizes, xsSizes: atcMobileSizes },
            1: { id: 'ad_srp_lstg_1', position: 'c', sizes: desktopSizes, xsSizes: atcMobileSizes },
            2: { id: 'ad_srp_lstg_2', position: 'd', sizes: desktopSizes, xsSizes: atcMobileSizes },
            3: { id: 'ad_srp_lstg_5', position: 'j', sizes: desktopSizes, xsSizes: atcMobileSizes },
            4: { id: 'ad_srp_lstg_6', position: 'k', sizes: desktopSizes, xsSizes: atcMobileSizes },
        },
        fluid: {
            0: { id: 'spotlightAd-toptier', position: 'b', sizes: [[300, 250], [728, 200], 'fluid'], xsSizes: [...atcMobileSizes, [1, 505]] },
            1: { id: 'ad_srp_lstg_1', position: 'c', sizes: [[300, 250], [728, 200], 'fluid'], xsSizes: [...atcMobileSizes, [1, 505]] },
            2: { id: 'ad_srp_lstg_2', position: 'd', sizes: [[300, 250], [728, 200], 'fluid'], xsSizes: [...atcMobileSizes, [1, 505]] },
            3: { id: 'ad_srp_lstg_5', position: 'j', sizes: [[300, 250], [728, 200], 'fluid'], xsSizes: [...atcMobileSizes, [1, 505]] },
            4: { id: 'ad_srp_lstg_6', position: 'k', sizes: [[300, 250], [728, 200], 'fluid'], xsSizes: [...atcMobileSizes, [1, 505]] },
        },
        listingCard: {
            0: { id: 'spotlightAd-toptier', position: 'b', sizes: desktopSizes, xsSizes: atcMobileSizes },
            1: { id: 'ad_srp_lstg_1', position: 'c', sizes: desktopSizes, xsSizes: atcMobileSizes },
            2: { id: 'ad_srp_lstg_2', position: 'd', sizes: desktopSizes, xsSizes: atcMobileSizes },
            3: { id: 'ad_srp_lstg_3', position: 'testvert', sizes: listingAdSizes, xsSizes: listingAdSizes },
            4: { id: 'ad_srp_lstg_5', position: 'j', sizes: [[300, 250], [728, 200], 'fluid'], xsSizes: [...atcMobileSizes, [1, 505]] },
            5: { id: 'ad_srp_lstg_6', position: 'k', sizes: [[300, 250], [728, 200], 'fluid'], xsSizes: [...atcMobileSizes, [1, 505]] },
        },
    },
    kbb: {
        desktop: {
            0: { id: 'kbbAdsClassfiedsInlineOEM', position: '29', sizes: desktopSizes },
            1: { id: 'kbbAdsClassfiedsInlineOEM2', position: '29', sizes: desktopSizes },
            2: { id: 'kbbAdsClassfiedsInlineOEM3', position: '29', sizes: desktopSizes },
            3: { id: 'kbbAdsClassfiedsInlineOEM4', position: '29', sizes: desktopSizes },
            4: { id: 'kbbAdsClassfiedsInlineOEM5', position: '29', sizes: desktopSizes },
        },
        mobile: {
            0: { id: 'kbbAdsMmaBanner1', position: 'M1', xsSizes: kbbMobileSizes },
            1: { id: 'kbbAdsMmaBanner2', position: 'M1', xsSizes: kbbMobileSizes },
            2: { id: 'kbbAdsMmaBanner3', position: 'M1', xsSizes: kbbMobileSizes },
            3: { id: 'kbbAdsMmaBanner4', position: 'M1', xsSizes: kbbMobileSizes },
            4: { id: 'kbbAdsMmaBanner5', position: 'M1', xsSizes: kbbMobileSizes },
        },
        desktopListingCard: {
            0: { id: 'kbbAdsClassfiedsInlineOEM', position: '29', sizes: desktopSizes },
            1: { id: 'kbbAdsClassfiedsInlineOEM2', position: '29', sizes: desktopSizes },
            2: { id: 'kbbAdsClassfiedsInlineOEM3', position: '29', sizes: desktopSizes },
            3: { id: 'kbbAdsClassfiedsInlineOEM4', position: 'testvert', sizes: listingAdSizes },
            4: { id: 'kbbAdsClassfiedsInlineOEM5', position: '29', sizes: desktopSizes },
            5: { id: 'kbbAdsClassfiedsInlineOEM6', position: '29', sizes: desktopSizes },
        },
        mobileListingCard: {
            0: { id: 'kbbAdsMmaBanner1', position: 'M1', xsSizes: kbbMobileSizes },
            1: { id: 'kbbAdsMmaBanner2', position: 'M1', xsSizes: kbbMobileSizes },
            2: { id: 'kbbAdsMmaBanner3', position: 'M1', xsSizes: kbbMobileSizes },
            3: { id: 'kbbAdsMmaBanner4', position: 'testvert', xsSizes: listingAdSizes },
            4: { id: 'kbbAdsMmaBanner5', position: 'M1', xsSizes: kbbMobileSizes },
            5: { id: 'kbbAdsMmaBanner6', position: 'M1', xsSizes: kbbMobileSizes },
        },
    },
};
